<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class="header-container fixed-top">
            <header class="header navbar navbar-expand-sm">
                <ul class="navbar-item theme-brand flex-row text-center me-auto">
                    <li class="nav-item theme-logo">
                        <a href="/Welcome.htm">
                            <img src="@/assets/images/logo.png" class="navbar-logo" alt="logo" />
                            <img src="@/assets/images/logo-small.png" class="navbar-logo-mobile" alt="logo" />
                        </a>
                    </li>
                    <li class="nav-item theme-text">
                        <a href="/Welcome.htm" class="nav-link">HS Portal</a>
                    </li>

                </ul>
                
                <div v-if="profile.dB_loggedInBack && profile.dB_isAdmin" class=" horizontal-menu brighter">
                    <a href="/clientlist">Clients</a>
                    <a href="/projectlist">Projects</a>
                    <a href="/users">Users</a>
                </div>
                
                
                <span v-if="isLoggedIn" class = "navbar-text ms-auto text-light d-inline-flex align-items-center">
                    <div id="client-logo" ></div>
                    <div :title="emaila"  :class="['me-2', 'user-name']">
                        <span v-if="tog" :class="profile.isLoggedInBack===false?'blueishhhh':''">{{ profile.username }} </span> 
                        <span @click="toggle_email" :class="isLoggedInBack===false?'blueishhhh':''">{{ profile.name }}</span>
                    </div>
                    <button class="btn m-2 transparentt p-0" @click="logoutHere">
                        <div>
                        <svg
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            stroke="currentColor"
                            stroke-width="2"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="css-i6dzq1"
                        >

                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        </div>

                    </button>
                </span>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN NAVBAR  -->
        <div class="sub-header-container">
            <header class="header navbar navbar-expand-sm">
                <!-- amburger menu -->
                <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-menu"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </a>
                <!-- 3 BUTTONS-->
                <div class="d-flex align-items-center topitems">
                    <div id="navbar-settings" class=""></div>
                </div>

                <!-- Portal vue/Teleport for Breadcrumb -->
                <div id="breadcrumb" class="vue-portal-target"></div>
                <div id="project-name" class="float-end"></div>
            </header>
        </div>
        <!--  END NAVBAR  -->
        <!--  BEGIN TOPBAR  -->
        <div class="topbar-nav header navbar" role="banner">
            <nav class="topbar">
                <ul class="list-unstyled menu-categories" id="topAccordion">
                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle autodroprown">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>{{ $t('dashboard') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                            <li>
                                <router-link to="/"> {{ $t('sales') }} </router-link>
                            </li>
                            <!-- <li>
                                <router-link to="/index2">{{ $t('analytics') }}</router-link>
                            </li> -->
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-cpu"
                                >
                                    <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                    <rect x="9" y="9" width="6" height="6"></rect>
                                    <line x1="9" y1="1" x2="9" y2="4"></line>
                                    <line x1="15" y1="1" x2="15" y2="4"></line>
                                    <line x1="9" y1="20" x2="9" y2="23"></line>
                                    <line x1="15" y1="20" x2="15" y2="23"></line>
                                    <line x1="20" y1="9" x2="23" y2="9"></line>
                                    <line x1="20" y1="14" x2="23" y2="14"></line>
                                    <line x1="1" y1="9" x2="4" y2="9"></line>
                                    <line x1="1" y1="14" x2="4" y2="14"></line>
                                </svg>
                                <span>{{ $t('apps') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        <ul class="collapse submenu list-unstyled">
                           
                            <li class="sub-sub-submenu-list">
                                <a href="javascript:;">
                                    Invoice
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-right"
                                    >
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>

                            </li>
                            
                        </ul>
                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-box"
                                >
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                                <span>{{ $t('components') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>

                    </li>

                    <li class="menu single-menu">
                        <a href="javascript:;" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-zap"
                                >
                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                </svg>
                                <span>{{ $t('ui_kit') }}</span>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-chevron-down"
                            >
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </a>
                        
                    </li>

                </ul>
            </nav>
        </div>
        <!--  END TOPBAR  -->
    </div>
</template>

<script setup>
    import { onMounted, ref,computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useStore } from 'vuex';
    import { auth } from '@/store/authStore'


    const profile = computed(() => auth.userProfile.value)
    console.log('profileeee',profile)

    const store = useStore();

    console.log("Here at Header")
    const clientId = ref(store.state.fe_project)
    const extraInfo = ref(null )
    const userName = ref("undefinedUser");
    const emaila = ref("");
    const userId = ref(-1);
    const labourRateComment = ref('')
    

    const adminUser = ref(false)

    const selectedLang = ref(null);
    const countryList = ref(store.state.countryList);

    const i18n = useI18n();
    const isLoggedIn = ref(true);
    const isLoggedInBack = ref(true);
    const tog = ref(false)

    const updateLoginStatus = () => {
        // Check if MSAL has any logged-in accounts
        const accounts = myMSALObj.getAllAccounts();
        isLoggedIn.value = accounts.length > 0;
    };

    const toggle_email = () => {
        console.log("toggling email")
        tog.value = !tog.value
    }
    onMounted(() => {

    });

    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };

    const changeLanguage = (item) => {
        selectedLang.value = item;
        window.$appSetting.toggleLanguage(item);

        i18n.locale.value = item.code;
    };

    let ctrlAltPressed = false;

    // Listen for keydown events to track Ctrl and Alt
    window.addEventListener("keydown", (event) => {
        if (event.ctrlKey && event.altKey) {
            ctrlAltPressed = true;
        }
    });

    // Listen for keyup events to reset the flag
    window.addEventListener("keyup", (event) => {
        if (event.key === "Control" || event.key === "Alt") {
            ctrlAltPressed = false;
        }
    });

    const logoutHere = () => {
        auth.logout()
        //window.dispatchEvent(new CustomEvent("ew_logout_user", { detail: { ctrlAltPressed } }))
    }
</script>

<style scoped>
.brighter a {
    color: #aaa !important;
    margin-left:20px;
}
@media (max-width: 768px) {
    .brighter a {
        margin-left: 5px;
    }
}
.subtitle {
    display: flex; 
    margin-left: 163px; 
    font-size: 16px; 
    margin-top: -10px;
}

.transparentt {
    background-color: transparent !important;
    border-color: transparent;
    border:none;
    padding-left:0px;
    padding-right: 0px;
}
#project-name {
    font-size:24px;
    font-weight: bolder;
    padding-right:10px;
    text-transform: uppercase;
}
  @media (max-width: 991px) {

    .nav-link {
      display:none;
    }

    #project-name {
        font-size: 19px;;
    }
  }
  .blueishhhh{
        color: #CCF !important;
  }

    .navbar-logo {
        display: block;
    }
    .navbar-logo-mobile {
        display: none;
    }
  @media (max-width: 768px) {

    .navbar-logo {
        display: none;
    }
    .navbar-logo-mobile {
        display: block;
    }
  }

  @media (max-width: 860px) {


    #client-logo {
        display:none;
    }
    #project-name {
        font-size: 16px;;
    }
    .user-name {
        display:none;   
    }

  }
  .small-btn {
    padding: 5px;
    border:none;
    background-color: transparent;

  }
  .topitems button, .topitems div .topitems .btn {
    padding-left:1px !important;
    padding-right:1px !important;
    
  }
</style>
